export default __webpack_public_path__ + "/static/media/login_bg.23ceb27f.png";